import {createReducer} from '@reduxjs/toolkit';
import {
  resetSelectedItemTypes,
  selectItemTypes,
} from '@src/actions/item-types.js';
import {loadSearch, searchSingleItem} from '@src/actions/search.js';
import {GOOD_ITEM_TYPES} from '@src/constants/item-types.ts';
import pickBy from 'lodash/pickBy';

export const initialState = {
  selected: pickBy(GOOD_ITEM_TYPES, Boolean),
};

const itemTypes = createReducer(initialState, builder => {
  builder.addCase(selectItemTypes, (state, {payload: itemTypes}) => {
    state.selected = itemTypes.reduce((types, id) => {
      return {
        ...types,
        [id]: true,
      };
    }, {});
  });

  builder.addCase(resetSelectedItemTypes, state => {
    state.selected = initialState.selected;
  });

  builder.addCase(loadSearch, (state, {payload: search}) => {
    state.selected = search.item_types.reduce((types, id) => {
      return {
        ...types,
        [id]: true,
      };
    }, {});
  });

  builder.addCase(searchSingleItem, (state, {payload: item}) => {
    state.selected = {[item.properties.item_type]: true};
  });
});

export default itemTypes;
